import React, { Component } from 'react';
import FormMatch from './FormMatch';
import { isEmpty } from 'lodash'
import ConfirmMatch from './ConfirmMatch';
import { Card, Table, TableCell, TableRow, TableHead, TableBody } from '@material-ui/core';
import { ReportProblemRounded } from '@material-ui/icons';
import { TableLayout } from '../../Menu/Stock/containers/Layout';
import Spin from '../../../commonModules/interface/Spin';
import { toast } from 'react-toastify';

class Matching extends Component {
    state = { 
        // match_dest_ref: "KIT_DLI_819BKDR",
        // match_dest_account:"1541155076-qHmMLbOI3WH",
        match_dest_email:"",
        match_dest_ref: "",
        match_dest_account:"",
        match_src_product:"",

        match_src_productDisplay:{
            value: "",
            label: "",
            ref: "",
        },
        match_dest_product:"",
        errors:{
            match_dest_email: "",
            match_dest_ref: "",
            match_dest_account: "",
            match_src_product:"",
            match_dest_product:"",
        },
        dest_product: {},
        confirm: false,
        list : {},

        step: 1,
        loading: false,
    }
    load = (setLoading = false) => {
        this.setState({
            loading: setLoading
        })
    }
    changeStep = (step) => {
        this.setState({
            step,
        })
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        this.setState({ [name]: value })
    }
    handleSelect = (option, field) => {
        let display = field+"Display"

        this.setState({ 
            [display]: option, 
            [field]: option.value
        }) 
    }
    validateStep1 = async () => {
        this.load(true)
        await this.findUserAccountID()
        if(this.state.match_dest_account){
            await this.getMatchList()
            this.setState({
                step: 2,
            })
        }
        this.load()
    }
    
    getMatchList = async () => {
        try {
            let req = await fetch('/stocks/match/list',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({data: this.state.match_dest_account}),
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log('====================================');
            console.log("get Match List", {res});
            console.log('====================================');
            
            if(!res.error){

                let list = {} 
                if(res) {
                    res.forEach( match => {
                        list[match.match_src_product] = match
                    } )
                }

                this.setState({
                    list,
                })

            } else {
                console.log('====================================');
                console.log(res.error);
                console.log('====================================');
            }
        } catch (error) {
            console.log('====================================');
            console.log(error);
            console.log('====================================');
        }
    }

    findUserAccountID = async () => {
        const { match_dest_email } = this.state;
        if( !isEmpty(match_dest_email)){

            /***** STEP 1 ******/
                // send email to global DB
                // check if email correspond to existing user and return Stock Account ID
                try {
                    let req = await fetch('/stocks/match/find/account',{
                        method:'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        body: JSON.stringify({email: match_dest_email}),
                        credentials: 'same-origin',
                    })
                    const res = await req.json()
                    console.log('====================================');
                    console.log("findUserAccountID", {res});
                    
                    if(!res.error && !isEmpty(res.accountID) ){
                        /***** STEP 2 ******/
                        // get current user's product list
                        if( isEmpty(this.props.PRODUCTS) ){
                            this.props.fetchProducts()
                        }
                        this.setState({
                            match_dest_account: res.accountID,
                            errors: {
                                ...this.state.errors,
                                match_dest_email: ""
                            }
                        })
        
                    } else {
                        toast.error( "Pas de compte correspondant à cet email")
                    }
                } catch (error) {
                    console.log("catch findUserAccountID", error);
                    
                    toast.error(  "Un Problème est survenu")
                }
        } else {
            this.setState({
                ...this.state,
                errors: {
                    ...this.state.errors,
                    match_dest_email: "Veuillez remplir ce champ"
                }
            })
        }        
    }

    validateStep2 = () => {
        const required = [
            "match_dest_ref",
            "match_src_product",
        ]
        let noErrors = true
        let errors = this.state.errors

        required.forEach( field => {
            if( isEmpty(this.state[field]) ) {
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }
        })
        console.log('=================VALIDATE STEP 2===================');
        console.log({errors});
        console.log('====================================');
        this.setState({
            errors
        })

        return noErrors
    }
    findProductInfo = async () => {
        const { match_dest_ref, match_dest_account } = this.state;
        // check if match_dest_ref exist 
        // if exist show confirm popup with all info before validateStep2
        this.load(true)
        if(this.validateStep2()){

            try {
                let req = await fetch('/stocks/match/find/product',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify({match_dest_ref, match_dest_account}),
                    credentials: 'same-origin',
           
                })
                const res = await req.json()
                console.log('====================================');
                console.log("findProductInfo", {res});
                console.log('====================================');
                
                if(!res.error && res.id){
                    
                    this.setState({
                        dest_product: res,
                        match_dest_product: res.id,
                        confirm: true
                    })
    
                } else {
                    toast.error(  "Pas de produit correspondant")
                }
            } catch (error) {
                console.log("catch findProductInfo", error);
                
                toast.error( "Un Problème est survenu")
            }
        }
        this.load()
    }
    
    handleSubmit = async () => {
        const { match_dest_account, match_src_product, match_dest_product, match_dest_ref, match_src_productDisplay } = this.state;
        console.log('====================================');
        console.log("IN SUBMIT");
        console.log('====================================');
        this.load(true)
        /***** STEP 3 ******/
            // create match in store DB
        let data = {
            match_dest_account,
            match_src_product,
            match_dest_product,
            match_dest_ref,
            match_src_ref: match_src_productDisplay.ref,
        }  
        try {
            let req = await fetch('/stocks/match/new',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify(data),
                credentials: 'same-origin',
        
            })
            const res = await req.json()
            console.log('====================================');
            console.log("handleSubmit", {res});
            console.log('====================================');
            
            if(!res.error && res.id){
                toast.success( "Association validée")
                this.setState({
                    match_dest_ref: "",
                    match_src_product:"",
                    match_src_productDisplay:{
                        value: "",
                        label: "",
                    },
                    match_dest_product:"",
                    dest_product: {},
                    confirm: false,
                })
                this.getMatchList()

            } else {
                toast.error(  res.error.error)
            }
        } catch (error) {
            console.log('====================================');
            console.log(error);
            console.log('====================================');
            toast.error( "Un problème est survenu")
        }
        this.load()
    }
    render() {
        const { confirm, match_src_product, match_dest_product, match_dest_account, list } = this.state;
        const { PRODUCTS } = this.props;
        console.log('================STATE====================');
        console.log(this.state);
        console.log('====================================');
        return (
            <div>
                <h3>Association de Produits</h3>

                <FormMatch 
                    {...this.state}
                    {...this.props}
                    handleChange={this.handleChange}
                    handleSelect={this.handleSelect}
                    findUserAccountID={this.findUserAccountID}
                    findProductInfo={this.findProductInfo}
                    validateStep1={this.validateStep1}
                    validateStep2={this.validateStep2}
                    changeStep={this.changeStep}
                />
                { !isEmpty(match_src_product)  && !isEmpty(list[match_src_product]) &&
                    <p className="c-orange text-center" style={{ fontWeight: "600", fontSize: "16px", color:"red"}}>
                        <ReportProblemRounded color="error" /> Attention ce produit a déjà été associé
                    </p>
                }
                {confirm && match_src_product && match_dest_product &&
                    <ConfirmMatch 
                        {...this.state}
                        src_product={PRODUCTS[match_src_product] || {}}
                        handleSubmit={this.handleSubmit}
                        handleClose={ () => this.setState({ confirm: false }) }
                    />
                }
                <hr/>
                {this.state.loading && <Spin noOverlay />}
                {match_dest_account && !isEmpty(list) && 
                <Card>
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                {/* <th>Account From</th> */}
                                <TableCell>Produit</TableCell>
                                <TableCell>Ref Source</TableCell>
                                {/* <TableCell>Account To</TableCell> */}
                                <TableCell>Ref Destination</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.values(list).map( match => (
                                <TableRow key={match.id}>
                                    <TableCell>{PRODUCTS[match.match_src_product] && `${PRODUCTS[match.match_src_product].name} - ${PRODUCTS[match.match_src_product].marque}`}</TableCell>
                                    <TableCell>{match.match_src_ref}</TableCell>
                                    {/* <TableCell>{accounts[match.match_dest_account]}</TableCell> */}
                                    <TableCell>{match.match_dest_ref}</TableCell>
                                    
                                </TableRow>
                            ))}
                        </TableBody>
                    </TableLayout>
                </Card>

                }

            </div>
        );
    }
}

export default Matching;
